import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import createaction from "../../context/action/user/createaction";
import Userlist from "./userlist";

const User = () => {
  const { recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);

  const [username, setusername] = useState();
  const [password, setpassword] = useState();
  const [role, setrole] = useState("admin");

  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  return (
    <div className="min-h-screen bg-slate-50 p-6 md:p-8">
      {/* Page Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">بەکارهێنەر</h1>
          <p className="text-sm text-slate-400 mt-0.5">بەڕێوەبردنی بەکارهێنەرانی سیستەم</p>
        </div>
      </div>

      {/* Add New User Form */}
      <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
        <div className="w-full">
          <label
            className={
              error
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="user_name"
          >
            ناو
          </label>
          <input
            className={
              error
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            id="user_name"
            type="text"
            placeholder=""
            onClick={(val)=>{val.target.select()}}
            value={username}
            onChange={(val) => setusername(val.target.value)}
            onFocus={() => seterror(false)}
          />
        </div>
        <div className="w-full">
          <label
            className={
              error1
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="password"
          >
            تێپەڕەوشە
          </label>
          <input
            className={
              error1
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            id="password"
            type="text"
            placeholder=""
            onClick={(val)=>{val.target.select()}}
            value={password}
            onChange={(val) => setpassword(val.target.value)}
            onFocus={() => seterror1(false)}
          />
        </div>
        <div className="w-full">
          <label
            htmlFor="cate"
            className="block text-sm font-medium text-slate-500 mb-1 text-right"
          >
            ڕۆڵ
          </label>
          <select
            id="cate"
            className="w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            value={role}
            onChange={(val) => setrole(val.target.value)}
          >
            <option value="admin">ئەدمین</option>
            <option value="casher">کاشێر</option>
          </select>
        </div>
        <div className="w-full">
          <button
            className="h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
            onClick={() => {
              if (username == "" || !username) {
                seterror(true);
                return false;
              }
              if (password == "" || !password) {
                seterror1(true);
                return false;
              }
              createaction(username, password, role)(recaller)(setrecaller)(
                initDispatch
              )(clear);
              // checkaction(username,password)(initDispatch)
            }}
          >
            زیادکردن
          </button>
        </div>
      </div>
      </div>

      {/* User List Section */}
      <Userlist />
    </div>
  );
};

export default User;
